import request from "../utils/request"

export const getLessonWithDemo = lessonId => request.get(`/lessons/${lessonId}`)
export const getNextSectionLink = lessonId => request.get(`/lessons/${lessonId}/next-section`)

// Silent by design: this is an audit write, not something the student is
// waiting on -- see postSilent in utils/request.js. It is a POST rather than a
// side effect on the GET above because the API disables CSRF checks, leaving
// SameSite=lax as the only guard, and lax permits cross-site top-level GETs.
export const logLessonView = lessonId => request.postSilent(`/lessons/${lessonId}/view`)
